<div class="container">
    <div class="spacer30"></div>
    <p style="padding: 10px; color: #263A3D; font-size: 28px;">Coming soon</p>
</div>